import {KTIcon} from '../../../../_metronic/helpers'

const OrgModalHeader = ({setOpenOrgModal}) => {
  return (
    <div className='modal-header'>
      <h2 className='fw-bolder'>Create Organization</h2>
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-users-modal-action='close'
        onClick={() =>  {
          setOpenOrgModal(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>

    </div>
  )
}

export {OrgModalHeader}
